import { RcClasses } from '../../../../foundation';
export var RcDialogActionsClasses = RcClasses([], 'RcDialogActions');
export var RcDialogActionsSizes = {
    small: [4],
    medium: [3, 6, 6],
};
